var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"notification-list"},[_vm._t("default",null,{"isCollapsed":_setup.isCollapsed,"toggleCollapse":_setup.toggleCollapse})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }